export const colors = {
  baseBg: '#ffffff',
  headerBg: 'rgba(0, 0, 0, 0.1)',
  shadow: 'rgba(0, 0, 0, 0.25)',
  darkShadowScroll: 'rgba(0, 0, 0, 0.3)',
  lightShadowScroll: 'rgba(255, 255, 255, 0.8)',
  buttonBg: 'rgba(255, 255, 255, 0.4)',
  buttonHoverBg: 'rgba(255, 255, 255, 0.2)',
  buttonActiveBg: 'rgba(255, 255, 255, 0.6)',
  secondaryBg: '#74b4cd',
  columnBg: '#e9e9eb',
  cardBg: '#ffffff',
  darkFont: '#000000',
  lightFont: '#ffffff',
  inputBg: '#fafbfc',
  inputBorder: '#dfe1e6',
  inputHoverBorder: '#4c9aff',
  baseButtonBg: '#cdd2d4',
  baseButtonHoverBg: '#c4c9cc',
  baseButtonActiveBg: '#b6bbbf',
  baseButtonColor: '#524e4e',
  submitButtonBg: '#5aac44',
  submitButtonHoverBg: '#61bd4f',
  submitButtonActiveBg: '#5aac44',
  errorBg: '#eb5a46',
  deleteButtonHoverBg: '#FF2400',
  deleteButtonActiveBg: '#8B0000',
  confirmButtonHoverBg: '#2AC800',
};
